import React, { useState, useEffect } from 'react';
import {
  Box,
  Paper,
  Typography,
  Button,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Snackbar,
  Alert
} from '@mui/material';
import { sendPaymentValidity } from '../api/payment';
import PaytrIframe from '../components/PaytrIframe';
import IyzicoIframe from '../components/IyzicoIframe';
import axios from 'axios';
import BuildIcon from '@mui/icons-material/Build';
import SchoolIcon from '@mui/icons-material/School';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import CodeIcon from '@mui/icons-material/Code';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Tooltip from '@mui/material/Tooltip';

// PORT numarası backend'e uygun şekilde alınmalı, örnek: 5001
const defaultPort = 5001;

const packages = [
  {
    type: 'Aylık',
    price: 299,
    desc: 'Aylık abonelik ile tüm özelliklere erişim.',
  },
  {
    type: 'Yıllık',
    price: 2990,
    desc: 'Yıllık abonelikte 2 ay bedava!'
  },
];

// pricingTable'ı dışa aktar
export const pricingTable = [
  {
    paket: 'Standart',
    aylik: '499 TL',
    yillik: '4.990 TL',
    calisanLimiti: 25,
    lokasyonLimiti: 1,
    rfidKartLimiti: 25,
    destek: 'E-posta',
    donanimFiyati: '2.500 TL',
    highlight: false,
    locationCount: 1,
    employeeCount: 25,
    rfidCount: 25,
    icon: <WorkspacePremiumIcon color="primary" sx={{ fontSize: 38, mb: 1 }} />
  },
  {
    paket: 'Plus',
    aylik: '799 TL',
    yillik: '7.990 TL',
    calisanLimiti: 50,
    lokasyonLimiti: 3,
    rfidKartLimiti: 50,
    destek: 'Telefon/E-posta',
    donanimFiyati: '2.350 TL',
    highlight: true,
    locationCount: 3,
    employeeCount: 50,
    rfidCount: 50,
    icon: <WorkspacePremiumIcon color="success" sx={{ fontSize: 38, mb: 1 }} />
  },
  {
    paket: 'Kurumsal',
    aylik: '1.499 TL',
    yillik: '14.990 TL',
    calisanLimiti: 150,
    lokasyonLimiti: 10,
    rfidKartLimiti: 150,
    destek: '7/24 Destek',
    donanimFiyati: '2.200 TL',
    highlight: false,
    locationCount: 10,
    employeeCount: 150,
    rfidCount: 150,
    icon: <WorkspacePremiumIcon color="secondary" sx={{ fontSize: 38, mb: 1 }} />
  },
  {
    paket: 'Özel',
    aylik: 'Teklif',
    yillik: 'Teklif',
    calisanLimiti: 'Sınırsız',
    lokasyonLimiti: 'Sınırsız',
    rfidKartLimiti: 'Sınırsız',
    destek: '7/24 VIP',
    donanimFiyati: 'Teklif',
    highlight: false,
    locationCount: 9999,
    employeeCount: 9999,
    rfidCount: 9999,
    icon: <WorkspacePremiumIcon color="action" sx={{ fontSize: 38, mb: 1 }} />
  },
];

const extraItems = [
  { kalem: 'Donanım kurulumu', fiyat: '2.000 – 10.000', aciklama: 'Turnike, kart okuyucu vs.', icon: <BuildIcon color="primary" sx={{ mr: 1, verticalAlign: 'middle' }} /> },
  { kalem: 'Eğitim', fiyat: '1.500', aciklama: 'Online veya yerinde kurulum', icon: <SchoolIcon color="success" sx={{ mr: 1, verticalAlign: 'middle' }} /> },
  { kalem: 'Yerinde destek', fiyat: '750 / gün', aciklama: 'Uzak destek zaten dahil', icon: <SupportAgentIcon color="secondary" sx={{ mr: 1, verticalAlign: 'middle' }} /> },
  { kalem: 'Özel geliştirme', fiyat: '500 – 1000 / saat', aciklama: 'API, ERP entegrasyonları', icon: <CodeIcon color="action" sx={{ mr: 1, verticalAlign: 'middle' }} /> },
];

export default function Payment() {
  const [selected, setSelected] = useState('Standart');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState('paytr');
  const [paytrToken, setPaytrToken] = useState(null);
  const [iyzicoToken, setIyzicoToken] = useState(null);
  const [showIframe, setShowIframe] = useState(false);
  const [validity, setValidity] = useState(null);
  const [showValidityAlert, setShowValidityAlert] = useState(false);
  const [locationCount, setLocationCount] = useState(1);
  const [employeeCount, setEmployeeCount] = useState(1);
  const [rfidCount, setRfidCount] = useState(1);
  const [postPayConfirmOpen, setPostPayConfirmOpen] = useState(false);
  const IYZICO_SANDBOX_LINK = 'https://sandbox.iyzi.link/AAE0FA';
  // Iyzico X-Frame-Options sameorigin, so we'll use popup instead of iframe
  const [payWindow, setPayWindow] = useState(null);
  const [pollTimerId, setPollTimerId] = useState(null);

  // Seçili paket için sayfa içi (popup dialog) Iyzico yönlendirmesi
  const startIyzicoPayment = async () => {
    try {
      // İyzico akışı başlıyor, metodu güvenceye al
      setPaymentMethod('iyzico');
      const paymentPayload = {
        amount: selectedPackage.price,
        port: defaultPort,
        paket: selected,
        location_count: locationCount,
        employee_count: employeeCount,
        rfid_count: rfidCount,
        successUrl: `${window.location.origin}/payment/callback?provider=iyzico&status=success`,
        cancelUrl: `${window.location.origin}/payment/callback?provider=iyzico&status=failed`
      };
      try {
        const res = await axios.post('https://pdks.bytebridge.com.tr/api/iyzico-token', paymentPayload);
        const checkoutUrl = res.data?.url || res.data?.checkoutUrl || res.data?.token || IYZICO_SANDBOX_LINK;
        // URL'i merkezde popup olarak aç
        const width = 720;
        const height = 800;
        const left = window.screenX + Math.max(0, (window.outerWidth - width) / 2);
        const top = window.screenY + Math.max(0, (window.outerHeight - height) / 2);
        const winRef = window.open(
          checkoutUrl,
          'iyzicoCheckout',
          `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes,status=yes,toolbar=no,menubar=no,location=yes`
        );
        setPayWindow(winRef);
        // Başarı durumunu algılamak için backend geçerlilik durumunu periyodik kontrol et
        startPaymentPolling(winRef);
      } catch (e) {
        // Backend başarısızsa sandbox linkini popup'ta aç
        const width = 720;
        const height = 800;
        const left = window.screenX + Math.max(0, (window.outerWidth - width) / 2);
        const top = window.screenY + Math.max(0, (window.outerHeight - height) / 2);
        const winRef = window.open(
          IYZICO_SANDBOX_LINK,
          'iyzicoCheckout',
          `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes,status=yes,toolbar=no,menubar=no,location=yes`
        );
        setPayWindow(winRef);
        startPaymentPolling(winRef);
      }
    } catch (e) {
      alert('Ödeme başlatılamadı!');
    }
  };

  useEffect(() => {
    // API geçerlilik süresini kontrol et
    axios.get('https://pdks.bytebridge.com.tr/api-validity', { params: { port: defaultPort } })
      .then(res => {
        // Hangi koşulda olursa olsun, valid_until yoksa veya hata varsa alert göster
        if ((res.data && res.data.valid_until)) {
          setValidity(res.data.valid_until);
          const now = new Date();
          const validDate = new Date(res.data.valid_until.replace(' ', 'T'));
          if (validDate - now < 7 * 24 * 60 * 60 * 1000 || validDate < now) {
            setShowValidityAlert(true);
          }
        }
        if ((res.data && res.data.error && res.data.success === false) || !(res.data && res.data.valid_until)) {
          setShowValidityAlert(true);
          setValidity(null);
        }
      })
      .catch((err) => {
        setShowValidityAlert(true);
      });
  }, []);

  // Popup callback'ten gelen sonucu dinle ve başarı durumunda kullanıcıya bildir
  useEffect(() => {
    const onMessage = (event) => {
      const data = event?.data || {};
      if (data.type === 'PAYMENT_RESULT' && (data.provider || '').toLowerCase() === 'iyzico') {
        if ((data.status || '').toLowerCase() === 'success') {
          // Popup'ı kapat ve polling'i durdur
          try { if (payWindow && !payWindow.closed) payWindow.close(); } catch {}
          if (pollTimerId) clearInterval(pollTimerId);
          setPollTimerId(null);
          setPayWindow(null);
          setSuccess(true);
        } else {
          alert('Ödeme başarısız veya iptal edildi.');
        }
      }
    };
    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
  }, [payWindow, pollTimerId]);

  // No iframe fallback needed; popup is used due to X-Frame-Options
  // Ödeme sonrası başarıyı algılamak için backend 'api-validity' üzerinden polling uygula
  const startPaymentPolling = (winRef) => {
    // Mevcut geçerlilik değerini temel alıp değişikliği yakalayalım
    let checks = 0;
    const maxChecks = 300; // ~10 dakika (2s aralık)
    const timer = setInterval(async () => {
      try {
        // Pencere manuel kapandıysa polling'i durdur
        if (!winRef || winRef.closed) {
          clearInterval(timer);
          setPollTimerId(null);
          setPayWindow(null);
          return;
        }
        checks += 1;
        const res = await axios.get('https://pdks.bytebridge.com.tr/api-validity', { params: { port: defaultPort } });
        // Eğer valid_until varsa ve now'dan ileri bir tarihteyse başarı kabul edelim
        const v = res.data?.valid_until;
        if (v) {
          const now = new Date();
          const vd = new Date(v.replace(' ', 'T'));
          if (vd > now) {
            // Başarı: popup'ı kapat ve kullanıcıya bildir
            try { winRef.close(); } catch {}
            clearInterval(timer);
            setPollTimerId(null);
            setPayWindow(null);
            setValidity(v);
            setSuccess(true);
            return;
          }
        }
        if (checks >= maxChecks) {
          clearInterval(timer);
          setPollTimerId(null);
          setPayWindow(null);
        }
      } catch (e) {
        // Ağ hatası vb. durumda polling'e devam et
      }
    }, 2000);
    setPollTimerId(timer);
  };

  // Bileşen unmount olursa temizle
  useEffect(() => {
    return () => {
      if (pollTimerId) clearInterval(pollTimerId);
      try { if (payWindow && !payWindow.closed) payWindow.close(); } catch {}
    };
  }, [pollTimerId, payWindow]);

  useEffect(() => {
    const pkg = pricingTable.find(p => p.paket === selected) || {};
    setLocationCount(pkg.locationCount || 1);
    setEmployeeCount(pkg.employeeCount || 1);
    setRfidCount(pkg.rfidCount || 1);
  }, [selected]);

  const handleValidityAlertClick = () => {
    setShowValidityAlert(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleChange = (event, newType) => {
    if (newType) setSelected(newType);
  };

  const handleMethodChange = (event, newMethod) => {
    if (newMethod) setPaymentMethod(newMethod);
  };

  const handlePay = async () => {
    setShowDialog(true);
  };

  const handleDialogClose = () => {
    setShowDialog(false);
  };

  const handleDialogConfirm = async () => {
    setLoading(true);
    setSuccess(false);
    setShowDialog(false);
    setShowIframe(false);
    try {
      const paymentPayload = {
        amount: selectedPackage.price,
        port: defaultPort,
        paket: selected,
        location_count: locationCount,
        employee_count: employeeCount,
        rfid_count: rfidCount
      };
      if (paymentMethod === 'paytr') {
        // Backend'den PayTR iframe token al (örnek endpoint: /api/paytr-token)
        const res = await axios.post('https://pdks.bytebridge.com.tr/api/paytr-token', paymentPayload);
        setPaytrToken(res.data.token); // token veya iframe html bekleniyor
        setShowIframe(true);
      } else if (paymentMethod === 'iyzico') {
        // Öncelik olarak verilen sandbox linkine yönlendir (yeni sekmede)
        // Eğer backend URL dönerse onu kullan, aksi halde sandbox linki aç
        try {
          const res = await axios.post('https://pdks.bytebridge.com.tr/api/iyzico-token', paymentPayload);
          const checkoutUrl = res.data?.url || res.data?.checkoutUrl || res.data?.token || IYZICO_SANDBOX_LINK;
          if (checkoutUrl && /^https?:\/\//i.test(checkoutUrl)) {
            window.open(checkoutUrl, '_blank', 'noopener');
            // Ödeme tamamlandıktan sonra kullanıcıdan onay iste
            setPostPayConfirmOpen(true);
          } else {
            // URL yoksa iframe ile göster (token HTML de olabilir)
            setIyzicoToken(res.data.token || res.data.html || res.data);
            setShowIframe(true);
          }
        } catch (e) {
          // Backend çağrısı başarısızsa doğrudan sandbox linki aç ve onay iste
          window.open(IYZICO_SANDBOX_LINK, '_blank', 'noopener');
          setPostPayConfirmOpen(true);
        }
      }
      // Ödeme başarı callback'i ile valid_until API'ye çağrı yapılacak
    } catch (err) {
      alert('Ödeme başlatılamadı!');
    }
    setLoading(false);
  };

  const handleFakePayment = async (validDay, paket) => {
    setLoading(true);
    try {
      // Seçili paketin içeriklerini pricingTable'dan al
      const pkg = pricingTable.find(p => p.paket === paket) || {};
      const payload = {
        paket: paket,
        location_count: pkg.locationCount || 1,
        employee_count: pkg.employeeCount || 1,
        rfid_count: pkg.rfidCount || 1,
        valid_until: new Date(Date.now() + validDay * 24 * 60 * 60 * 1000).toISOString().slice(0, 10),
        port: defaultPort
      };
      await sendPaymentValidity(defaultPort, payload.valid_until, 'Test Kullanıcı', payload);
      setValidity(payload.valid_until);
      setSuccess(true);
    } catch (err) {
      alert('Test için hızlı ödeme başarısız!');
    }
    setLoading(false);
  };

  const selectedPackage = pricingTable.find(p => p.paket === selected) || packages.find(p => p.type === selected);

  // Seçili paketin fiyatı (aylık/yıllık mantığına göre)
  const selectedPrice = typeof selectedPackage.aylik === 'number' ? selectedPackage.aylik : (selectedPackage.aylik || selectedPackage.price);

  return (
    <>
      {/* Süre uyarısı sağ üst köşe */}
      <Snackbar
        open={showValidityAlert}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        onClose={() => setShowValidityAlert(false)}
        autoHideDuration={null}
        style={{ zIndex: 20000 }}
      >
        <Alert
          onClick={handleValidityAlertClick}
          severity="warning"
          sx={{ cursor: 'pointer', minWidth: 320, fontSize: 18, fontWeight: 'bold', boxShadow: 4 }}
          variant="filled"
        >
          {validity ? (
            new Date(validity.replace(' ', 'T')) < new Date()
              ? <>Abonelik süreniz <b>{validity}</b> tarihinde sona ERMİŞ. Ödeme yapmak için tıklayın.</>
              : <>Abonelik süreniz <b>{validity}</b> tarihinde sona erecek. Ödeme yapmak için tıklayın.</>
          ) : (
            <>Abonelik süresi bitmiş! Ödeme yapmak için tıklayın.</>
          )}
        </Alert>
      </Snackbar>
      <Snackbar open={success} anchorOrigin={{ vertical: 'top', horizontal: 'right' }} autoHideDuration={3500} onClose={() => setSuccess(false)}>
        <Alert severity="success" variant="filled" sx={{ fontWeight: 'bold', fontSize: 18 }}>
          Ödemeniz başarıyla alınmıştır! Aboneliğiniz {validity} tarihine kadar uzatıldı.
        </Alert>
      </Snackbar>
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        mb: { xs: 2, sm: 4 },
        minHeight: '100vh',
        boxSizing: 'border-box',
        overflowX: 'hidden',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
          <Tooltip title="Ödeme işlemlerini bu sayfadan yapabilirsiniz.">
            <InfoOutlinedIcon color="primary" style={{ marginRight: 8, cursor: 'pointer' }} />
          </Tooltip>
          <h2 style={{ margin: 0 }}>Ödeme</h2>
        </div>
        <Paper elevation={8} sx={{
          p: { xs: 1.5, sm: 4 },
          mb: { xs: 1.5, sm: 3 },
          maxWidth: '100%',
          width: '100%',
          background: 'linear-gradient(120deg, #f8fafc 60%, #e3f2fd 100%)',
          borderRadius: { xs: 2, sm: 6 },
          boxShadow: 10,
          boxSizing: 'border-box',
          overflowX: 'auto',
          mx: 'auto',
        }}>
          <Typography variant="h4" sx={{ fontWeight: 'bold', mb: { xs: 1.5, sm: 2 }, color: '#1976d2', letterSpacing: 1, fontSize: { xs: 22, sm: 32 }, wordBreak: 'break-word', textAlign: 'center' }}>
            <span style={{ color: '#1565c0' }}>Siz de Dijital PDKS ile</span> <span style={{ color: '#43a047' }}>Zaman Kazanın!</span>
          </Typography>
          <Typography variant="h6" sx={{ mb: { xs: 2, sm: 3 }, color: '#333', textAlign: 'center', fontSize: { xs: 15, sm: 20 }, wordBreak: 'break-word' }}>
            <span style={{color:'#1976d2',fontWeight:'bold'}}>7/24</span> erişim, <span style={{color:'#43a047',fontWeight:'bold'}}>hızlı kurulum</span> ve <span style={{color:'#ff9800',fontWeight:'bold'}}>güvenli ödeme</span> avantajlarıyla <b>şimdi abone olun!</b>
          </Typography>
          <Box sx={{ mt: 4, mb: 4, px: { xs: 0.5, sm: 2, md: 4 }, overflowX: 'hidden', width: '100%', maxWidth: '100%' }}>
            <Grid container spacing={{ xs: 2, sm: 3, md: 4 }} justifyContent="center">
              {pricingTable.map((row, idx) => (
                <Grid item xs={12} sm={6} md={3} key={row.paket} sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'stretch',
                  minWidth: 0,
                  maxWidth: '100%',
                }}>
                  <Paper elevation={row.highlight ? 8 : 2} sx={{
                    p: { xs: 2, sm: 3 },
                    borderRadius: 3,
                    textAlign: 'center',
                    border: row.highlight ? '2px solid #1976d2' : '1px solid #eee',
                    boxShadow: row.highlight ? '0 0 16px #1976d233' : undefined,
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    width: '100%',
                    maxWidth: '100%',
                  }}>
                    {row.icon}
                    <Typography variant="h5" sx={{ fontWeight: 'bold', color: row.highlight ? '#1976d2' : '#222', letterSpacing: 1, fontSize: { xs: 18, sm: 24 }, wordBreak: 'break-word', textAlign: 'center' }}>{row.paket}</Typography>
                    <Typography variant="h3" sx={{ fontWeight: 'bold', color: row.highlight ? '#1976d2' : '#222', my: { xs: 1, sm: 2 }, fontSize: { xs: 22, sm: 32, md: 38 }, wordBreak: 'break-word', textAlign: 'center' }}>{row.aylik} <span style={{ fontSize: 16 }}>/ay</span></Typography>
                    <Typography variant="body1" color="text.secondary" align="center" sx={{ minHeight: 38, fontSize: { xs: 13, sm: 15 }, wordBreak: 'break-word' }}>{row.aciklama}</Typography>
                    <Box sx={{ mt: { xs: 1.5, sm: 2.5 }, width: '100%' }}>
                      <Typography variant="body2" color="text.secondary">Yıllık: <b>{row.yillik}</b></Typography>
                      <Typography variant="body2" color="text.secondary">Çalışan Limiti: <b>{row.calisanLimiti}</b></Typography>
                      <Typography variant="body2" color="text.secondary">Lokasyon Limiti: <b>{row.lokasyonLimiti}</b></Typography>
                      <Typography variant="body2" color="text.secondary">RFID Kart Limiti: <b>{row.rfidKartLimiti}</b></Typography>
                      <Typography variant="body2" color="text.secondary">Destek: <b>{row.destek}</b></Typography>
                      <Typography variant="body2" color="text.secondary">Donanım: <b>{row.donanimFiyati}</b></Typography>
                    </Box>
                    <Button
                      variant={row.paket === selected ? 'contained' : (row.highlight ? 'contained' : 'outlined')}
                      color={row.paket === selected ? 'primary' : (row.highlight ? 'primary' : 'inherit')}
                      sx={{ mt: 2, width: '100%', fontWeight: 600, fontSize: 18 }}
                      onClick={() => {
                        if (row.paket === selected) {
                          // Seçili paketse Iyzico linkine yönlendir
                          startIyzicoPayment();
                        } else {
                          // Değilse seç
                          setSelected(row.paket);
                        }
                      }}
                    >
                      {row.paket === selected ? 'Ödeme yap' : 'Seç'}
                    </Button>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </Box>
          <Typography variant="h6" sx={{ mt: { xs: 3, sm: 5 }, mb: { xs: 1.5, sm: 2 }, color: '#1976d2', fontWeight: 'bold', fontSize: { xs: 15, sm: 20 }, wordBreak: 'break-word' }}>Ek Kalemler (Opsiyonel)</Typography>
          <Grid container spacing={1} sx={{ background: '#f3f6f9', borderRadius: 3, p: { xs: 1, sm: 2 }, width: '100%', m: 0, boxSizing: 'border-box', overflowX: 'auto' }}>
            <Grid item xs={4}><b>Kalem</b></Grid>
            <Grid item xs={4}><b>Fiyat</b></Grid>
            <Grid item xs={4}><b>Açıklama</b></Grid>
            {extraItems.map((item, i) => (
              <React.Fragment key={i}>
                <Grid item xs={4} sx={{ display: 'flex', alignItems: 'center' }}>
                  {item.icon}{item.kalem}
                </Grid>
                <Grid item xs={4}>{item.fiyat}</Grid>
                <Grid item xs={4}>{item.aciklama}</Grid>
              </React.Fragment>
            ))}
          </Grid>
        </Paper>
      </Box>
      <Dialog open={showDialog} onClose={handleDialogClose}>
        <DialogTitle>Ödeme Onayı</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Seçili paket: <b>{selectedPackage.paket}</b><br />
            Tutar: <b>{selectedPrice} TL</b><br />
            Devam etmek istiyor musunuz?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="secondary">İptal</Button>
          <Button onClick={handleDialogConfirm} color="primary" variant="contained" autoFocus>Onayla ve Öde</Button>
        </DialogActions>
      </Dialog>
      {/* Iyzico sonrası onay diyaloğu */}
      <Dialog open={postPayConfirmOpen} onClose={() => setPostPayConfirmOpen(false)}>
        <DialogTitle>Ödeme Durumu</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Ödeme sayfasını yeni sekmede açtık. Eğer ödeme başarıyla tamamlandıysa lütfen aşağıdaki "Başarılı" butonuna basın.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setPostPayConfirmOpen(false)} color="secondary">İptal</Button>
          <Button
            onClick={async () => {
              // Başarılı kabul edip geçerlilik süresini güncelle (örnek: 30 gün)
              await handleFakePayment(30, selected);
              setPostPayConfirmOpen(false);
            }}
            color="primary"
            variant="contained"
          >
            Başarılı
          </Button>
        </DialogActions>
      </Dialog>
      {showIframe && paymentMethod === 'paytr' && <PaytrIframe token={paytrToken} />}
      {/* Iyzico dialog removed due to X-Frame-Options; using popup instead */}
      {success && <Typography color="success.main" align="center" sx={{ mt: 2 }}>Paket süresi başarıyla güncellendi!</Typography>}
    </>
  );
}
